import { render, staticRenderFns } from "./GetStartedStageInfo.vue?vue&type=template&id=38ef2702&scoped=true&"
import script from "./GetStartedStageInfo.vue?vue&type=script&lang=js&"
export * from "./GetStartedStageInfo.vue?vue&type=script&lang=js&"
import style0 from "./GetStartedStageInfo.vue?vue&type=style&index=0&id=38ef2702&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ef2702",
  null
  
)

export default component.exports